import { CityLandingPage } from "../components/CityLandingPage";

export function WebdesignMeissen() {
  return <CityLandingPage city="Meißen" citySlug="meissen" variant="webdesign" />;
}
